import Col from 'antd/es/col';

import { SFCampaignPromotionItemViewModel } from '@api/index';

import {
  Container,
  DetailButton,
  TourName,
  ImageContainer,
  Summary,
} from './styled';

const Card = ({ title, href, image }: SFCampaignPromotionItemViewModel) => {
  return (
    <Container prefetch={false} href={href || ''}>
      <ImageContainer image={image} />
      <Summary gutter={15}>
        <Col xs={16}>
          <TourName>{title}</TourName>
        </Col>
        <Col xs={8}>
          <DetailButton>İncele</DetailButton>
        </Col>
      </Summary>
    </Container>
  );
};

export default Card;
